module.exports = __webpack_public_path__ + "static/media/foodics-logo.ac08b4e1.svg";